import React, { useState } from 'react';

const DocumentationCards = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const styles = {
    container: {
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem',
      boxSizing: 'border-box',
      '@media (max-width: 768px)': {
        padding: '1rem'
      }
    },

    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '1.5rem',
      alignItems: 'stretch',
      '@media (max-width: 640px)': {
        gridTemplateColumns: '1fr',
        gap: '1rem'
      }
    },

    card: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '1.5rem',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden',
      '@media (max-width: 768px)': {
        padding: '1.25rem'
      },
      '@media (max-width: 480px)': {
        padding: '1rem'
      },
      '@media (hover: none)': {
        // Disable hover effects on touch devices
        transform: 'none !important',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08) !important'
      }
    },

    title: {
      color: '#002366',
      fontSize: '1.25rem',
      fontWeight: '700',
      marginBottom: '0.75rem',
      position: 'relative',
      zIndex: 1,
      '@media (max-width: 768px)': {
        fontSize: '1.125rem'
      },
      '@media (max-width: 480px)': {
        fontSize: '1rem'
      }
    },

    description: {
      color: '#4a5568',
      fontSize: '0.875rem',
      lineHeight: '1.5',
      marginBottom: '0.5rem',
      position: 'relative',
      zIndex: 1,
      '@media (max-width: 480px)': {
        fontSize: '0.8125rem'
      }
    },

    topBar: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '4px',
      background: 'linear-gradient(90deg, #002366 0%, #0055ff 100%)'
    }
  };

  const cards = [
    {
      title: "FIRST START",
      description: "In-depth guide on setting up your newly-purchased device.",
      gradient: 'linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%)'
    },
    {
      title: "CONFIGURATION",
      description: "Detailed configuration guide with examples.",
      gradient: 'linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%)'
    },
    {
      title: "MANUAL",
      description: "Comprehensive user manual encompassing all device functions.",
      gradient: 'linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%)'
    },
    {
      title: "CROWD SUPPORT",
      description: "Crowd Support Forum for receiving help from other users.",
      gradient: 'linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%)'
    }
  ];

  const getCardStyle = (index, gradient) => ({
    ...styles.card,
    background: gradient,
    transform: hoveredIndex === index ? 'translateY(-3px)' : 'none',
    boxShadow: hoveredIndex === index 
      ? '0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)'
      : styles.card.boxShadow
  });

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        {cards.map((card, index) => (
          <div
            key={index}
            style={getCardStyle(index, card.gradient)}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => {
              // Add click handler for touch devices
              if (window.matchMedia('(hover: none)').matches) {
                // Handle touch interaction
              }
            }}
          >
            <div style={styles.topBar} />
            <h3 style={styles.title}>{card.title}</h3>
            <p style={styles.description}>{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentationCards;